export default __webpack_public_path__ + "static/media/plan_b.0f34dfed.png";